import React from 'react';

export default function UnAuth(){

    return(
        <>
        <h1>Access Denied</h1>
        <p>Please Login</p>
        
        </>
    )
}